<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :model="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-row>
            <el-col :span="6">
              <el-form-item label-width
                            prop="sku"
                            label="SKU">
                <el-input v-model="form.sku"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label-width prop="product_id" label="商品ID">
                <el-input v-model="form.product_id"></el-input>
              </el-form-item>
            </el-col>-->
            <el-col :span="6">
              <el-form-item label-width
                            prop="title"
                            label="商品标题">
                <el-input v-model="form.title"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label-width prop="product_status" label="商品状态">
                <el-input v-model="form.product_status"></el-input>
              </el-form-item>
            </el-col>-->
            <!-- 
            <el-col :span="12">
              <el-form-item label-width prop="create_time" label="创建时间">
                <el-date-picker v-model="form.create_time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </el-col>-->

            <el-col :span="6">
              <el-form-item label-width
                            prop="num"
                            label="数量">
                <!-- <el-input v-model="form.num"></el-input> -->
                <number-range v-model="form.num" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="platform_from"
                            label="平台">
                <el-select clearable
                           v-model="form.platform_from"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in tradefrom"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="profession"
                            label="行业">
                <el-select clearable
                           v-model="form.profession"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in platlists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="business"
                            label="商家">
                <el-select v-loading="ptnListLoading"
                           clearable
                           v-model="form.business"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in ptnlists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="store"
                            label="店铺">
                <el-select v-loading="shopListLoading"
                           clearable
                           v-model="form.store"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in shoplists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-show="searchAreaStatus">
            <el-col style="width:450px">
              <el-form-item label-width
                            prop="update_time"
                            label="更新时间">
                <!-- <el-input v-model="form.update_time"></el-input>-->
                <el-date-picker v-model="form.update_time"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width:360px"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="update_desc"
                            label="更新说明">
                <el-input v-model="form.update_desc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithoutImport">
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开"}}</el-button>
      </action-line>
    </el-card>

    <!-- el-table -->

    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column prop="sku"
                       align="center"
                       header-align="center"
                       label="SKU"></el-table-column>
      <!-- <el-table-column prop="product_id" align="center" header-align="center" label="商品ID"></el-table-column> -->
      <el-table-column prop="title"
                       align="center"
                       header-align="center"
                       label="商品标题"
                       show-overflow-tooltip
                       width="220px"></el-table-column>
      <el-table-column prop="update_desc"
                       align="center"
                       header-align="center"
                       label="更新说明"
                       show-overflow-tooltip
                       width="220px"></el-table-column>
      <!-- <el-table-column prop="product_title" align="center" header-align="center" label="商品标题"></el-table-column> -->
      <!-- <el-table-column prop="product_status" align="center" header-align="center" label="商品状态"></el-table-column> -->
      <el-table-column prop="num"
                       align="center"
                       header-align="center"
                       label="数量"></el-table-column>
      <!-- <el-table-column prop="create_time" align="center" header-align="center" label="创建时间" width="180px"></el-table-column> -->
      <el-table-column prop="update_time"
                       align="center"
                       header-align="center"
                       label="更新时间"
                       width="180px"></el-table-column>
      <el-table-column prop="platform_from"
                       align="center"
                       header-align="center"
                       label="平台"></el-table-column>
      <el-table-column prop="profession"
                       align="center"
                       header-align="center"
                       label="行业"></el-table-column>
      <el-table-column prop="business"
                       align="center"
                       header-align="center"
                       label="商家"></el-table-column>
      <el-table-column prop="store"
                       align="center"
                       header-align="center"
                       label="店铺"></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import handleExport from '@/common/mixins/handle-export'

import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin, handleExport],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    async getTableData() {
      this.loading = true
      let { data, err } = await this.axiosApi(
        Desc.inventoryLists_api,
        this.queryPrdlists
      )
      // console.log("data", data);
      this.loading = false
      this.tableData = data.data.data.data
      this.total = parseInt(data.data.data.total)
      dealReturn(data, err)
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/base/inventory/index.vue